import { createContext, useContext } from "react";

/** Interface */
interface IInputWrapperContext {
	error?: string;
}

/** Context */
export const InputWrapperContext = createContext<IInputWrapperContext>({});

/** Hooks */
export function useFormContext() {
	return useContext(InputWrapperContext);
}
